import type { Environment } from '@openeducation/oe-it-services';

import TeacherLiveClassDao from './dao/teacher-live-class.dao';

export abstract class TeacherLiveClassService {
  static getOlderLiveClasses(env: Environment, teacherId?: number) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    return TeacherLiveClassDao.getOlderLiveClasses(env, teacherId);
  }

  static sendGroupLiveClassFeedback(
    env: Environment,
    studentId: number,
    classroomId: number,
    teacherFeedback: string,
    teacherId?: number
  ) {
    if (!teacherId || !studentId || !classroomId || !teacherFeedback) {
      throw new Error(
        'Missing required parameters (teacherId, studentId, classroomId, teacherFeedback)'
      );
    }

    return TeacherLiveClassDao.sendGroupLiveClassFeedback(
      env,
      studentId,
      classroomId,
      teacherFeedback,
      teacherId
    );
  }
}
